import React from "react";
import { toast } from "react-toastify";
import { FlexRow, BackButton, TableWrap, SmallTable, SmallTh, SmallTd, NetworkBadge } from "./styledComponents";

function AddressView({ wallet, addresses, onBack }) {
  return (
    <div style={{ marginTop: 16 }}>
      <FlexRow gap={8} style={{ justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <h4
          style={{
            fontSize: 13,
            color: "#94a3b8",
            margin: 0,
            fontWeight: 600,
          }}
        >
          {wallet} Wallet · Addresses
        </h4>
        <BackButton onClick={onBack}>Back to chart</BackButton>
      </FlexRow>
      <TableWrap>
        <SmallTable>
          <thead>
            <tr>
              <SmallTh>Chain</SmallTh>
              <SmallTh>Label</SmallTh>
              <SmallTh>Address</SmallTh>
              <SmallTh>Network</SmallTh>
              <SmallTh>Actions</SmallTh>
            </tr>
          </thead>
          <tbody>
            {addresses && addresses.length > 0 ? (
              addresses.map((addr, idx) => (
                <tr key={`${wallet}-addr-${idx}`}>
                  <SmallTd>{addr.chain}</SmallTd>
                  <SmallTd>{addr.label}</SmallTd>
                  <SmallTd style={{ fontFamily: "monospace", fontSize: "11px" }}>{addr.address}</SmallTd>
                  <SmallTd>
                    <NetworkBadge>{addr.network}</NetworkBadge>
                  </SmallTd>
                  <SmallTd>
                    <button
                      style={{
                        fontSize: 11,
                        borderRadius: 999,
                        border: "1px solid #1f2937",
                        padding: "2px 8px",
                        background: "#020617",
                        color: "#e5e7eb",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        navigator.clipboard?.writeText(addr.address);
                        toast.success("Address copied to clipboard");
                      }}
                    >
                      Copy
                    </button>
                  </SmallTd>
                </tr>
              ))
            ) : (
              <tr>
                <SmallTd colSpan={5} style={{ textAlign: "center", padding: "20px", color: "#94a3b8" }}>
                  No addresses available
                </SmallTd>
              </tr>
            )}
          </tbody>
        </SmallTable>
      </TableWrap>
    </div>
  );
}

export default AddressView;

